import { render, staticRenderFns } from "./backend-category.vue?vue&type=template&id=5f16f60e&"
import script from "./backend-category.vue?vue&type=script&lang=js&"
export * from "./backend-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports